import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const resolveMediaUrl = (path) => {
  if (!path || typeof path !== "string") return null;

  const trimmed = path.trim();
  if (!trimmed) return null;

  // Base64 or Blob URLs
  if (trimmed.startsWith("data:") || trimmed.startsWith("blob:")) {
    return trimmed;
  }

  let normalized = trimmed;

  // Strip localhost/127.0.0.1 with port 8001 if present
  normalized = normalized.replace(/^http:\/\/(127\.0\.0\.1|localhost):800\d/i, "");

  // Handle absolute URLs
  if (normalized.startsWith("http://") || normalized.startsWith("https://")) {
    if (normalized.includes("/checklists/checklists/media/")) {
      normalized = normalized.replace("/checklists/checklists/media/", "/checklists/media/");
    } else if (normalized.includes("/media/") && !normalized.includes("/checklists/media/")) {
      normalized = normalized.replace("/media/", "/checklists/media/");
    }
    return normalized;
  }

  const domainBase = "https://konstruct.world";

  // Normalize relative paths to start with /checklists/media/
  if (normalized.startsWith("/checklists/media/")) {
    // Correct relative path
  } else if (normalized.startsWith("checklists/media/")) {
    normalized = `/${normalized}`;
  } else if (normalized.startsWith("/media/")) {
    normalized = `/checklists${normalized}`;
  } else if (normalized.startsWith("media/")) {
    normalized = `/checklists/${normalized}`;
  } else {
    normalized = `/checklists/media/${normalized.replace(/^\/+/, "")}`;
  }

  return `${domainBase}${normalized}`;
};

export const formatObservationDateTime = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  if (hours === 0) {
    hours = 12;
  }

  const formattedHours = String(hours).padStart(2, "0");

  return `${day}/${month}/${year} ${formattedHours}:${minutes} ${period}`;
};

export const formatObservationDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};